<template>
    <VirtualsResults :gameName="'diamond'"></VirtualsResults>
</template>

<script>
import VirtualsResults from './Components/VirtualsResults';
export default {
    name: 'diamond',
    components: {
        VirtualsResults,
    },
};
</script>
